import { render, staticRenderFns } from "./TabSonsPosturas.vue?vue&type=template&id=678d3070&scoped=true"
import script from "./TabSonsPosturas.vue?vue&type=script&lang=js"
export * from "./TabSonsPosturas.vue?vue&type=script&lang=js"
import style0 from "./TabSonsPosturas.vue?vue&type=style&index=0&id=678d3070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d3070",
  null
  
)

export default component.exports